module.exports = __webpack_public_path__ + "media/images/noa/noa-group-9033b3a94e3c3ee3c0958ee25947ced0.png";